/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Math.Easing.Cubic

module.exports = {

    In: require('./In'),
    Out: require('./Out'),
    InOut: require('./InOut')

};



//////////////////
// WEBPACK FOOTER
// ./math/easing/cubic/index.js
// module id = 291
// module chunks = 0